(function ($, window, document) {
    $(document).ready(function () {
        $('.bonusProgramFaq .faq-item-head').bind('click', function(){
            $(this).parents(".faq-item").toggleClass("active")
        })
    })
})(jQuery, window, document);
